import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function MagicLinkVerify() {
  const { token } = useParams();
  const [status, setStatus] = useState('Verifying...');
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`/api/magic-link/verify/${token}`)
      .then((r) => {
        if (!r.ok) throw new Error('Invalid or expired link');
        return r.json();
      })
      .then((data) => {
        login(data.token, data.user);
        setStatus('Signed in! Redirecting...');
        setTimeout(() => navigate('/'), 1000);
      })
      .catch(() => {
        setStatus('This link is invalid or has expired.');
      });
  }, [token, login, navigate]);

  return (
    <div className="buddy-info window">
      <div className="title-bar">
        <span className="title-bar-text">
          <span>Magic Link</span>
        </span>
      </div>
      <div className="window-body">
        <p>{status}</p>
        {status.includes('invalid') && (
          <button onClick={() => navigate('/login')}>Sign In</button>
        )}
      </div>
    </div>
  );
}
